function updateShippingBar() {
  const bar = document.querySelector('free-shipping-bar');
  if (!bar) return;

  const threshold = parseFloat(bar.getAttribute('threshold'));
  const totalPrice = parseFloat(bar.getAttribute('total-price'));
  const percentage = Math.min(Math.round((totalPrice / threshold) * 100), 100);

  const fill = document.querySelector('.shipping-bar-fill');
  if (!fill) return;

  fill.style.setProperty('width', percentage + '%', 'important');
}

function observeBar() {
  const bar = document.querySelector('free-shipping-bar');
  if (!bar) return;

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'total-price') {
        updateShippingBar();
      }
    });
  });

  observer.observe(bar, { attributes: true });
}

// Watch for cart drawer re-renders and re-attach observer
const domObserver = new MutationObserver(function() {
  observeBar();
  updateShippingBar();
});

domObserver.observe(document.body, { childList: true, subtree: true });

// Run on load
document.addEventListener('DOMContentLoaded', function() {
  updateShippingBar();
  observeBar();
});